import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UtilityFunctions } from '../../utilities/utility-func';
import { AppService } from '../../services/app.service';
import { StorageService } from '../../services/storage.service';
import { Config } from '../../config/config';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  redirectUrl: String;
  public userpermissions: any = {};
  public userDetails = [];
  // public routeMapping = {
  //   alarmConfiguration: '/p/configurations/alarms',
  //   alarmEvents: '/p/alarm-events',
  //   thingsStudio: '/p/things-studio',
  //   assets: '/p/assets',
  //   dashboard: '/p/dashboard',
  //   visualization: '/p/visualization',
  //   devices: '/p/channelConfiguration/gatewayDevices/devicelist',
  //   licenceType: '/p/license-management',
  //   manualEntry: '/p/configurations/manual-entry',
  //   maps: '/p/maps',
  //   masterConfiguration: '/p/configurations/masterConfig',
  //   reports: '/p/reports',
  //   dataSnapshot: ['/p/dataSnapshot', 'p/eLogbook', '/p/eLogbook/dashboard'],
  //   ruleEngine: '/p/configurations/rule-engine',
  //   scada: '/p/sld',
  //   sites: '/p/configurations/sites',
  //   tags: '/p/configurations/masterConfig/parameters',
  //   trends: '/p/trends',
  //   userManagement: '/p/configurations/userManagement',
  //   emailGateWay: 'p/configurations/emailGateway',
  //   smsGateWay: 'p/configurations/smsgateway',
  //   channelConfiguration: 'p/channelConfiguration/gatewayDevices/gatewaylist',
  //   shiftManagementGroup: ['p/configurations/shiftmanagement', '/p/configurations/shiftmanagement/editshift/'],
  //   deviceGroup: 'p/configurations/businessGroups/deviceGroups',
  //   tagGroup: 'p/configurations/businessGroups/tagGroups',
  //   lookupConfiguration: ['/p/configurations/lookupconfiguration' , '/p/configurations/lookup_tables'],
  //   aiRuleEngine: 'p/configurations/ai-rule-engine',
  //   auditLogs: 'p/auditLogs',
  //   cloudChannelConfiguration: 'p/cloud/channelConfiguration',
  //   oeeConfiguration: 'p/oeeConfiguration',
  //   eLogbookConfiguration: 'p/eLogbookConfiguration',
  //   standardReports: ['/p/oee-dashboard', '/p/energyManagement', '/p/energySummary'],
  //   backUpScheduler: '/p/backUpScheduler',
  //   pipelineBuilder: '/p/pipelines',
  //   // Jobs: '/p/pipelines/pipelinebuilder/jobs',
  //   printers: '/p/configurations/printers',
  //   deviceManager: '/p/device-manager',
  //   apps: '/p/apps',
  //   aiDashboard: '/p/ds-engine',
  //   spc_reports: '/p/spc-reports',
  //   locker: 'p/configurations/locker',
  //   oeeDashboard: ['p/oee', '/p/oee/summary'],
  //   eLogbook: ['p/eLogbook', '/p/eLogbook/dashboard'],
  // };
  public routeMappingChildren = {
    userManagement: {
      userList: 'p/configurations/userManagement/user_list',
      userAccess: 'p/configurations/userManagement/useraccess',
      workGroup: 'p/configurations/userManagement/workGroups',
    },
    masterConfiguration: {
      gatewayModels: 'p/configurations/masterConfig/gatewaymodel',
      sensorDeviceModels: 'p/configurations/masterConfig/devicemodels',
      virtualDevice: 'p/configurations/masterConfig/virtualDevice',
      tags: 'p/configurations/masterConfig/parameters',
      batchEntry: 'p/configurations/masterConfig/batchentry',
      units: 'p/configurations/masterConfig/unit-master',
      unitConverter: 'p/configurations/masterConfig/unitconverter',
      multiplicationFactor:  'p/configurations/masterConfig/multiplicationFactors',
      thresholds: 'p/configurations/masterConfig/thresholds',
      shiftManagementGroup: 'p/configurations/masterConfig/timeslot-group',
      pipelineComponents: 'p/configurations/masterConfig/pipeline-config',
      aiModels: 'p/configurations/masterConfig/aimodel',
      clients: 'p/configurations/masterConfig/client',
      protocol: 'p/configurations/masterConfig/protocol',
      downtimeReason: '/p/configurations/masterConfig/down-time',
    },
  };
  public breadCrumbTitlesList = {
    '/p/configurations/sites': 'Configurations / Sites',
    '/p/channelConfiguration/gatewayDevices': '',
    '/p/configurations/userManagement/user_list': 'Configurations / User Management / User List',
    '/p/configurations/userManagement/user_list/add': 'Configurations / User Management / Add or Edit User',
    '/p/configurations/userManagement/user_list/edit': 'Configurations / User Management / Add or Edit User',
    '/p/configurations/userManagement/useraccess': 'Configurations / User Management / User Roles',
    '/p/configurations/userManagement/workGroups': 'Configurations / User Management / User Groups',
    '/p/configurations/businessGroups/deviceGroups': ' Configurations / Device Groups',
    '/p/configurations/businessGroups/tagGroups': 'Configurations / Tag Groups',
    '/p/configurations/alarms': 'Configurations / Alarms',
    '/p/configurations/alarms/addorupdatealarms/new': 'Configurations / Alarms/ Add or Update Alarms',
    '/p/configurations/rule-engine': 'Configurations / Rule Engine',
    '/p/configurations/manual-entry': 'Configurations / Manual Entry',
    '/p/configurations/shiftmanagement': 'Configurations / Shift Management',
    '/p/configurations/shiftmanagement/editshift/': 'Configurations / Shift Management / Add or Edit',
    '/p/configurations/emailGateway': 'Configurations / Email Gateway',
    '/p/configurations/emailGateway/addemailGateway': 'Configurations / Email Gateway / Add or Edit',
    '/p/configurations/emailGateway/editemailGateway/': 'Configurations / Email Gateway / Add or Edit',
    '/p/configurations/smsgateway': 'Configurations / SMS Gateway',
    '/p/configurations/smsgateway/addsmsgateway': 'Configurations / SMS Gateway / Add or Edit',
    '/p/configurations/smsgateway/editsmsgateway/': 'Configurations / SMS Gateway / Add or Edit',
    '/p/configurations/masterConfig/gatewaymodel': 'Configurations / Master Configuration / GateWay Model',
    '/p/configurations/masterConfig/devicemodels': 'Configurations / Master Configuration / Device Model',
    '/p/configurations/masterConfig/virtualDevice': 'Configurations / Master Configuration / Virtual Device',
    'p/configurations/masterConfig/pipeline-config': 'Configurations / Master Configuration / Pipeline Builder Components',
    '/p/configurations/masterConfig/parameters': 'Configurations / Master Configuration / Tags',
    '/p/configurations/masterConfig/batchentry': 'Configurations / Master Configuration / Batch Entry',
    '/p/configurations/masterConfig/unit-master': 'Configurations / Master Configuration / Units',
    '/p/configurations/masterConfig/unitconverter': 'Configurations / Master Configuration / Unit Converter',
    '/p/configurations/masterConfig/multiplicationFactors': 'Configurations / Master Configuration / Multiplication Factor',
    '/p/configurations/masterConfig/thresholds': 'Configurations / Master Configuration / Thresholds',
    '/p/configurations/masterConfig/timeslot-group': 'Configurations / Master Configuration / Shift Management Group',
    '/p/configurations/lookup_tables/': 'Configurations / LookUp Tables',
    '/p/configurations/lookupconfiguration': 'Configurations / LookUp Configuration',
    '/p/configurations/ai-rule-engine': 'Configurations / AI Rule Engine',
    '/p/channelConfiguration/gatewayDevices/devicelist': 'Channel Configuration / Device Configuration',
    'p/configurations/masterConfig/client': 'Configurations / Master Configuration / Clients',
    '/p/configurations/masterConfig/protocol' : 'Configurations / Master Configuration / Protcols',
    '/p/pipelines/pipelinebuilder': 'Pipeline Builder',
    '/p/pipelines/pipelinebuilder/jobs': 'Pipeline Builder / Jobs',
    '/p/configurations/printers' : 'Configurations / Printers',
    '/p/device-manager': 'Configurations / Device Manager',
    'p/configurations/locker' : 'Configurations / Locker',
    '/p/configurations/masterConfig/down-time': 'Configurations / Master Configuration / Downtime Reasons',
    '/p/channel-config/pipelineBuilder': 'Channel Configuration Pipeline Builder',
  };
  public breadCrumbTitle = '';

  constructor(
    private _router: Router,
    private _utility: UtilityFunctions,
    private appservice: AppService,
    private session: StorageService,
    ) { }
  storeUserDetails(userObj: string) {
    const encryptedUserObj = this._utility.encryptPassword(userObj);
    localStorage.setItem('userDetails', encryptedUserObj);
  }
  getUserDetails() {
    try {
      let userDetails;
      const userId = this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ID);
      if (userId) {
        userDetails = {
          user_id: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ID),
          user_name: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_NAME),
          user_type: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ROLE),
          user_role: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ROLE),
          userId: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ID),
        };
      } else {
        userDetails = null;
      }

      return userDetails;
    } catch (error) {
      console.error(error);
    }
  }
  deleteUserDetails() {
    localStorage.removeItem('userDetails');
    this.session.api.local.clear();
    this._router.navigate(['p/login']);
  }
  isLoggednIn() {
    return this.getUserDetails() !== null;
  }
  logout() {
    this.deleteUserDetails();
    this._router.navigate(['p/login']);
  }

  // User Permissions Set and Get Functions for AuthGuard Start

  public setUserPermissions(details: any) {
    this.userpermissions = details;
  }

  getUserPermissions(key) {
    try {
      // if (this._utility.getSessionKey()) {
        const encryptedUserDetails = localStorage.getItem('userDetails');
        const decryptedUserDetails = this._utility.decrypt(encryptedUserDetails);
        let userdetails = JSON.parse(decryptedUserDetails);
        userdetails = userdetails['user_role_permissions'];
        if (key !== '') {
          return decryptedUserDetails && decryptedUserDetails !== '' ? userdetails[key] : null;
        } else if (key === '') {
          return decryptedUserDetails && decryptedUserDetails !== '' ? JSON.parse(decryptedUserDetails) : null;
        }
      // }
      return null;
    } catch (error) {
      console.error(error);
    }
  }

  // getMappingDetails() {
  //   this.appservice.getRouteMapping().subscribe((data) => {
  //     this.routeMapping = data;
  //   });
  // }
}
